import { getProtocol } from "./getProtocol";
import { isStartWithProtocol } from "./isStartWithProtocol";

export const addProtocol = (text: string): string =>
  isStartWithProtocol(text) ? text : `${getProtocol()}${text}`;
